"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _coreMixins = require("@legacy-vfuk/core-mixins");

var defaultTheme = function defaultTheme(ws10Theme) {
  return {
    appearance: {
      primary: {
        backgroundColor: ws10Theme.color.secondary6["default"],
        textColor: ws10Theme.color.monochrome1["default"]
      }
    },
    cornerStyle: (0, _coreMixins.createMixin)(function (theme, align, backgroundColor) {
      return (0, _styledComponents.css)(["&:after{content:'';position:absolute;top:0;left:0;bottom:0;right:0;}", " ", ""], align === 'left' && (0, _styledComponents.css)(["padding-right:32px;&:after{border-right:32px solid ", ";border-radius:32px 0px;}"], backgroundColor), align === 'right' && (0, _styledComponents.css)(["padding-left:32px;&:after{border-left:32px solid ", ";border-radius:0px 32px;}"], backgroundColor));
    })
  };
};

var _default = defaultTheme;
exports["default"] = _default;
//# sourceMappingURL=MarketingShout.theme.js.map